<template>
    <v-container grid-list-xs fluid>
        <v-card min-height="800px">
            <v-toolbar color="primary" dense dark>
                <v-spacer></v-spacer>
                <h3>Shift Analysis Tool</h3>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row justify="center">
                    <v-col cols="3">
                        <v-text-field
                            name="Start Time"
                            label="Start Time"
                                v-mask="'####-##-##'"
                                placeholder="YYYY-MM-DD"
                            v-model="$store.state.analytics.StartTime"

                        ></v-text-field>
                    </v-col>
                    
                    <v-col cols="3">
                        <v-text-field
                            name="Start Time"
                            label="End Time"
                                v-mask="'####-##-##'"
                                placeholder="YYYY-MM-DD"
                            v-model="$store.state.analytics.EndTime"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
            <v-container grid-list-xs>
                 <v-row>
                    <v-col v-for="itm in btn" :key="itm.id" cols="3" >
                        <v-btn block  @click="getBtn(itm)" large  color="primary">{{ itm.title }}</v-btn>
                    </v-col>
                 </v-row>
            </v-container>
        </v-card>   
    </v-container>
</template>
<script>
import { mask } from 'vue-the-mask';
export default {
    directives: { mask },
    data: function() {
        return {
            btn:[
                {id:1,title:'View By Shift', Url:'shift-analytics/shift'},
                {id:2,title:'View By Truck', Url:'shift-analytics/truck'},
                {id:3,title:'View By Driver', Url:'shift-analytics/driver'},
                {id:4,title:'View By Customer', Url:'shift-analytics/customer'},
                {id:5,title:'View By Truck-Yard', Url:'shift-analytics/truck-yard'},
                {id:6,title:'View By Terminal', Url:'shift-analytics/terminal'},
                {id:7,title:'View By Station', Url:'shift-analytics/station'},
                {id:8,title:'View Regions Totals', Url:'shift-analytics/region-totals'},
                {id:9,title:'View By Company Truck', Url:'shift-analytics/company-truck'},
                {id:10,title:'View By Company Truck Actual Profit', Url:'shift-analytics/company-actual-profit'},
                {id:11,title:'Revenues by Invoice', Url:'shift-analytics/revenues-by-invoice'},
                {id:12,title:'Expenses by Statements', Url:'shift-analytics/expenses-by-statements'},
                {id:13,title:'Fuel Efficiency', Url:'shift-analytics/efficiency/truck'},
                {id:14,title:'Hours & Kms Standar vs Actual', Url:'shift-analytics/hours-kms/standar-vs-actual'},
                {id:15,title:'View By Trailer', Url:'shift-analytics/trailer'},
            ]
        };
    },
    mounthed(){

    },
    methods: {
        getBtn(itm){
            console.log(itm);
            this.$store.state.analytics.url = itm.Url;
            this.$store.state.analytics.title = itm.title;
            if(itm.id == 11 || itm.id == 12){
                this.$router.push('/shift-analytics/expenses-or-revenues');
            }else{
                this.$router.push('/shift-analytics-detail');
            }
            
        }
    }
}
</script>